import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { yellowAnchor, blueAnchor, redAnchor } from '@model';
import { changePropertyInArr } from '@utils/widget';

Map.defaultProps = {
  locationsInfo: [],
  width: 480,
  height: 305,
};
Map.propTypes = {
  locationsInfo: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
};

function CompanyLocationMap(props) {
  const mapRef = React.createRef();
  const { locationsInfo: tempLocationInfo, width, height } = props;

  const { buyerLabel, targetLabel } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );

  useEffect(() => {
    for (const i in tempLocationInfo) {
      for (const item of tempLocationInfo[i]?.locations || []) {
        if (item && !tempLocationInfo[i].isManualInput) {
          if (!item) {
            return;
          }
          item.location = {
            lat: item.latitude || 0,
            lng: item.longitude || 0,
          };
          item.companyName = tempLocationInfo[i].companyName;
          item.icon = i === '1' ? 'targetImage' : 'buyerImage';
        } else {
          if (!item) {
            return;
          }
          item.location = {
            lat: null,
            lng: null,
          };
        }
      }
    }

    //相同城市不同公司的icon变为一样
    const companyInfo = changePropertyInArr(
      [
        ...(tempLocationInfo[0].locations || []),
        ...(tempLocationInfo[1]?.locations || []),
      ],
      'city',
      'companyName',
      'icon',
      'sameImage',
    );
    if (mapRef.current && window.google) {
      // 地图
      const gmap = new window.google.maps.Map(mapRef.current, {
        center: {
          lat: (companyInfo[0] && companyInfo[0].location.lat) || 0,
          lng: (companyInfo[0] && companyInfo[0].location.lng) || 0,
        },
        zoom: 3,
      });

      // 标注
      const legend = document.createElement('div');
      legend.innerHTML = `<div
        class="map-legend company-location"
        id="legend"
      >
        <img src="${yellowAnchor}" alt="buyer" />
        ${buyerLabel}
        <img src="${blueAnchor}" alt="target" />
        ${targetLabel}
        <img src="${redAnchor}" alt="mixure" />
        ${buyerLabel}&${targetLabel}
      </div>`;
      gmap.controls[window.google.maps.ControlPosition.BOTTOM_CENTER].push(
        legend,
      );

      const targetImage = {
        url: blueAnchor,
        size: new window.google.maps.Size(20, 25),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(10, 25),
      };

      const buyerImage = {
        url: yellowAnchor,
        size: new window.google.maps.Size(20, 25),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(10, 25),
      };

      const sameImage = {
        url: redAnchor,
        size: new window.google.maps.Size(20, 25),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(10, 25),
      };
      // 所有打點
      companyInfo.map((info, i) => {
        if (!info || !info.city) {
          return null;
        }
        const tipContent = `<div class='marker-tooltip'>
          <h1 class='marker-tooltip-title'>${info.companyName}</h1>
          <div class='marker-tooltip-content'>${
            info.address ? `${info.address}, ` : ''
          }${info.city ? `${info.city}, ` : ''}${
          info.state ? `${info.state}, ` : ''
        }${info.country}</div>
          </div>`;
        const infoWindow = new window.google.maps.InfoWindow({
          content: tipContent,
        });
        const icon =
          info.icon === 'targetImage'
            ? targetImage
            : info.icon === 'buyerImage'
            ? buyerImage
            : sameImage;
        const tempMaker = new window.google.maps.Marker({
          map: gmap,
          icon,
          position: info.location,
        });

        setTimeout(() => {
          tempMaker.addListener('mouseover', function () {
            infoWindow.open(gmap, tempMaker);
          });
          tempMaker.addListener('mouseout', function () {
            infoWindow.close(gmap, tempMaker);
          });
        }, 1000);
        return tempMaker;
      });
    }
  }, [tempLocationInfo, targetLabel, buyerLabel]);
  return (
    <div
      className="company-location-map"
      style={{ width, height }}
      ref={mapRef}
    />
  );
}

export default React.memo(CompanyLocationMap);
